import React, { useState } from 'react';
import { Box, Modal, Typography, TextField, Button } from '@mui/material';
import { TOKENS } from '../state/colors';
import { fs } from '../state/typography';

interface ReasonDialogProps {
  titulo: string;
  label: string;
  onCancelar: () => void;
  onConfirmar: (motivo: string) => void;
}

export const ReasonDialog: React.FC<ReasonDialogProps> = ({ titulo, label, onCancelar, onConfirmar }) => {
  const [motivo, setMotivo] = useState('');

  return (
    <Modal open onClose={onCancelar}>
      <Box
        sx={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          backgroundColor: '#fff',
          borderRadius: '20px',
          padding: '28px 30px',
          boxShadow: '0 24px 60px rgba(46,36,48,.28)',
        }}
      >
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: fs(17), fontWeight: 700, color: TOKENS.ink, marginBottom: '14px' }}>
          {titulo}
        </Typography>
        <TextField
          data-testid="reason-input"
          fullWidth
          multiline
          minRows={3}
          label={label}
          value={motivo}
          onChange={(e) => setMotivo(e.target.value)}
          sx={{ marginBottom: '18px' }}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <Button onClick={onCancelar} sx={{ textTransform: 'none', fontFamily: 'Poppins, sans-serif', color: TOKENS.text }}>
            Cancelar
          </Button>
          <Button
            data-testid="reason-confirm"
            disabled={!motivo.trim()}
            onClick={() => onConfirmar(motivo.trim())}
            sx={{
              textTransform: 'none',
              fontFamily: 'Poppins, sans-serif',
              backgroundColor: TOKENS.purple,
              color: '#fff',
              borderRadius: '999px',
              padding: '6px 18px',
              '&:hover': { backgroundColor: TOKENS.purpleDark },
              '&.Mui-disabled': { backgroundColor: TOKENS.faint, color: '#fff' },
            }}
          >
            Confirmar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
